import { bl_fi_mst_item_entity_pricing_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FinancialItemEntityPriceListingImportFileHelperContainer extends BaseContainerModel {
  bl_fi_mst_item_entity_pricing_import_file_helper: bl_fi_mst_item_entity_pricing_import_file_helper_RowClass = new bl_fi_mst_item_entity_pricing_import_file_helper_RowClass();
}
